<template>
  <div class="search">
    <div class="row no-gutters justify-content-end">
      <div class="search-input-wrap" data-v-step="search">
        <input
          type="text"
          class="form-control"
          v-debounce:1s="submitSearch"
          placeholder="Search for your slide"
          :value="query"
        />
        <div class="search-reset" v-if="query">
          <img
            src="@/assets/images/icon-close.png"
            class="search-reset-icon"
            alt="Reset search"
            @click="resetSearch"
          />
        </div>
      </div>
      <div class="">
        <button
          class="button button-secondary w-100 search-button"
          @click="submitSearch(query)"
        >
          <span>Search</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Search',
  computed: mapState('filtering', ['query']),
  methods: {
    resetSearch () {
      this.$store.commit('filtering/setQuery', '')
      if (this.$route.name !== 'diagrams') {
        this.$router.push({ name: 'diagrams' })
      }
    },
    submitSearch (query) {
      this.$store.commit('filtering/setQuery', query)
      this.$gtag.event('search', {
        event_label: query
      })
      this.$matomo && this.$matomo.trackSiteSearch(query)
      if (this.$route.name !== 'slides') {
        this.$router.push({ name: 'slides' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  position: relative;

  & > .row {
    flex: 1 1 auto;
    & > div {
      width: auto;
    }
  }
  .search-input-wrap {
    min-width: 453px;
  }
  .search-button {
    justify-content: center;
    min-width: 242px;
  }
  .col-9 {
    position: relative;
  }
  .form-control {
    height: 50px;
    padding: 0px 20px;
    border-radius: 28px;
    border: 2px solid #d7d7d7;
  }
  .btn {
    font-weight: 700;
    padding: 12px 0 12px;
    border: 1px solid #913d88;
    border-left: none;
    &-icon {
      font-size: 15px;
      color: #fff;
      &:before {
        content: '';
        display: inline-block;
        vertical-align: -6px;
        width: 19px;
        height: 21px;
        background: url('@/assets/images/icon-search.png') no-repeat 0 0;
      }
    }
  }
  &-reset {
    position: absolute;
    right: 20px;
    top: 12px;
    &-icon {
      max-width: 25px;
      height: auto;
      display: block;
      cursor: pointer;
      opacity: 0.6;
      transition: opacity 0.25s linear;
      &:hover {
        opacity: 1;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1220px) {
  .search {
    .search-input-wrap {
      min-width: 48%;
    }
  }
}
@media screen and (max-width: 768px) {
  .search {
    .btn {
      span {
        display: none;
      }
    }
    .form-control {
      height: 44px;
    }
    .btn {
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }
}
</style>
